import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1TeamsList: build.query<
      ApiPortalV1TeamsListApiResponse,
      ApiPortalV1TeamsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    apiPortalV1TeamsCreate: build.mutation<
      ApiPortalV1TeamsCreateApiResponse,
      ApiPortalV1TeamsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/`,
        method: "POST",
        body: queryArg.team,
      }),
    }),
    apiPortalV1TeamsRetrieve: build.query<
      ApiPortalV1TeamsRetrieveApiResponse,
      ApiPortalV1TeamsRetrieveApiArg
    >({
      query: (queryArg) => ({ url: `/api/portal/v1/teams/${queryArg.id}/` }),
    }),
    apiPortalV1TeamsUpdate: build.mutation<
      ApiPortalV1TeamsUpdateApiResponse,
      ApiPortalV1TeamsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.team,
      }),
    }),
    apiPortalV1TeamsPartialUpdate: build.mutation<
      ApiPortalV1TeamsPartialUpdateApiResponse,
      ApiPortalV1TeamsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedTeam,
      }),
    }),
    apiPortalV1TeamsDestroy: build.mutation<
      ApiPortalV1TeamsDestroyApiResponse,
      ApiPortalV1TeamsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1TeamsLeadersRetrieve: build.query<
      ApiPortalV1TeamsLeadersRetrieveApiResponse,
      ApiPortalV1TeamsLeadersRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/${queryArg.id}/leaders/`,
      }),
    }),
    apiPortalV1TeamsMembersRetrieve: build.query<
      ApiPortalV1TeamsMembersRetrieveApiResponse,
      ApiPortalV1TeamsMembersRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/${queryArg.id}/members/`,
      }),
    }),
    apiPortalV1TeamsSetLeaderCreate: build.mutation<
      ApiPortalV1TeamsSetLeaderCreateApiResponse,
      ApiPortalV1TeamsSetLeaderCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/${queryArg.id}/set-leader/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    apiPortalV1TeamsSetMembersCreate: build.mutation<
      ApiPortalV1TeamsSetMembersCreateApiResponse,
      ApiPortalV1TeamsSetMembersCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/${queryArg.id}/set-members/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    apiPortalV1TeamsAllRetrieve: build.query<
      ApiPortalV1TeamsAllRetrieveApiResponse,
      ApiPortalV1TeamsAllRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/teams/all/` }),
    }),
    apiPortalV1TeamsExportRetrieve: build.query<
      ApiPortalV1TeamsExportRetrieveApiResponse,
      ApiPortalV1TeamsExportRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/teams/export/` }),
    }),
    apiPortalV1TeamsImportCreate: build.mutation<
      ApiPortalV1TeamsImportCreateApiResponse,
      ApiPortalV1TeamsImportCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/import/`,
        method: "POST",
        body: queryArg.fileUpload,
        params: {
          mode: queryArg.mode,
        },
      }),
    }),
    apiPortalV1TeamsImportTemplateRetrieve: build.query<
      ApiPortalV1TeamsImportTemplateRetrieveApiResponse,
      ApiPortalV1TeamsImportTemplateRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/teams/import-template/` }),
    }),
    apiPortalV1TeamsLeaderTeamsRetrieve: build.query<
      ApiPortalV1TeamsLeaderTeamsRetrieveApiResponse,
      ApiPortalV1TeamsLeaderTeamsRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/teams/leader-teams/` }),
    }),
    apiPortalV1TeamsMineRetrieve: build.query<
      ApiPortalV1TeamsMineRetrieveApiResponse,
      ApiPortalV1TeamsMineRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/teams/mine/` }),
    }),
    apiPortalV1TeamsOrganizationMembersRetrieve: build.query<
      ApiPortalV1TeamsOrganizationMembersRetrieveApiResponse,
      ApiPortalV1TeamsOrganizationMembersRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/teams/organization-members/` }),
    }),
    apiPortalV1TeamsRebuildMembersCreate: build.mutation<
      ApiPortalV1TeamsRebuildMembersCreateApiResponse,
      ApiPortalV1TeamsRebuildMembersCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/teams/rebuild-members/`,
        method: "POST",
        body: queryArg.team,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1TeamsListApiResponse =
  /** status 200  */ PaginatedTeamListRead;
export type ApiPortalV1TeamsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type ApiPortalV1TeamsCreateApiResponse = /** status 201  */ TeamRead;
export type ApiPortalV1TeamsCreateApiArg = {
  team: Team;
};
export type ApiPortalV1TeamsRetrieveApiResponse =
  /** status 200  */ TeamDetailRead;
export type ApiPortalV1TeamsRetrieveApiArg = {
  /** A unique integer value identifying this team. */
  id: number;
};
export type ApiPortalV1TeamsUpdateApiResponse = /** status 200  */ TeamRead;
export type ApiPortalV1TeamsUpdateApiArg = {
  /** A unique integer value identifying this team. */
  id: number;
  team: Team;
};
export type ApiPortalV1TeamsPartialUpdateApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsPartialUpdateApiArg = {
  /** A unique integer value identifying this team. */
  id: number;
  patchedTeam: PatchedTeam;
};
export type ApiPortalV1TeamsDestroyApiResponse = unknown;
export type ApiPortalV1TeamsDestroyApiArg = {
  /** A unique integer value identifying this team. */
  id: number;
};
export type ApiPortalV1TeamsLeadersRetrieveApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsLeadersRetrieveApiArg = {
  /** A unique integer value identifying this team. */
  id: number;
};
export type ApiPortalV1TeamsMembersRetrieveApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsMembersRetrieveApiArg = {
  /** A unique integer value identifying this team. */
  id: number;
};
export type ApiPortalV1TeamsSetLeaderCreateApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsSetLeaderCreateApiArg = {
  /** A unique integer value identifying this team. */
  id: number;
  body: {
    /** Employee ID to make leader */
    employee_id: number;
  };
};
export type ApiPortalV1TeamsSetMembersCreateApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsSetMembersCreateApiArg = {
  /** A unique integer value identifying this team. */
  id: number;
  body: {
    employee_ids: number[];
  };
};
export type ApiPortalV1TeamsAllRetrieveApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsAllRetrieveApiArg = void;
export type ApiPortalV1TeamsExportRetrieveApiResponse = /** status 200  */ Blob;
export type ApiPortalV1TeamsExportRetrieveApiArg = void;
export type ApiPortalV1TeamsImportCreateApiResponse = /** status 200  */ object;
export type ApiPortalV1TeamsImportCreateApiArg = {
  /** Import mode: 'validate' for validation only, 'import' to apply the import. */
  mode?: string;
  fileUpload: FileUpload;
};
export type ApiPortalV1TeamsImportTemplateRetrieveApiResponse =
  /** status 200  */ Blob;
export type ApiPortalV1TeamsImportTemplateRetrieveApiArg = void;
export type ApiPortalV1TeamsLeaderTeamsRetrieveApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsLeaderTeamsRetrieveApiArg = void;
export type ApiPortalV1TeamsMineRetrieveApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsMineRetrieveApiArg = void;
export type ApiPortalV1TeamsOrganizationMembersRetrieveApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsOrganizationMembersRetrieveApiArg = void;
export type ApiPortalV1TeamsRebuildMembersCreateApiResponse =
  /** status 200  */ TeamRead;
export type ApiPortalV1TeamsRebuildMembersCreateApiArg = {
  team: Team;
};
export type Team = {
  name: string;
  department?: number | null;
  color?: string | null;
  external_id?: string | null;
  /** Parent team in the organizational hierarchy */
  parent_team?: number | null;
  leader?: number | null;
  leader_can_invite?: boolean;
  sort_order?: number | null;
};
export type TeamRead = {
  id: number;
  name: string;
  organization: number;
  organization_name: string;
  department?: number | null;
  color?: string | null;
  external_id?: string | null;
  /** Parent team in the organizational hierarchy */
  parent_team?: number | null;
  parent_team_name: string | null;
  leader?: number | null;
  leader_id: number | null;
  leader_name: string;
  leader_email: string | null;
  leader_can_invite?: boolean;
  sort_order?: number | null;
  created_by: number | null;
  created_at: string;
  updated_at: string;
  member_count: string;
};
export type PaginatedTeamList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Team[];
};
export type PaginatedTeamListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TeamRead[];
};
export type TeamDetail = {
  name: string;
  organization: number;
  department?: number | null;
  color?: string | null;
  external_id?: string | null;
  parent_team?: number | null;
  leader?: number | null;
  leader_can_invite?: boolean;
  sort_order?: number | null;
  created_by?: number | null;
};
export type TeamDetailRead = {
  id: number;
  name: string;
  organization: number;
  organization_name: string;
  department?: number | null;
  color?: string | null;
  external_id?: string | null;
  parent_team?: number | null;
  parent_team_name: string | null;
  leader?: number | null;
  leader_id: number | null;
  leader_name: string;
  leader_email: string | null;
  leader_can_invite?: boolean;
  sort_order?: number | null;
  created_by?: number | null;
  created_at: string;
  updated_at: string;
  members: string;
  member_count: string;
};
export type PatchedTeam = {
  name?: string;
  department?: number | null;
  color?: string | null;
  external_id?: string | null;
  /** Parent team in the organizational hierarchy */
  parent_team?: number | null;
  leader?: number | null;
  leader_can_invite?: boolean;
  sort_order?: number | null;
};
export type PatchedTeamRead = {
  id?: number;
  name?: string;
  organization?: number;
  organization_name?: string;
  department?: number | null;
  color?: string | null;
  external_id?: string | null;
  /** Parent team in the organizational hierarchy */
  parent_team?: number | null;
  parent_team_name?: string | null;
  leader?: number | null;
  leader_id?: number | null;
  leader_name?: string;
  leader_email?: string | null;
  leader_can_invite?: boolean;
  sort_order?: number | null;
  created_by?: number | null;
  created_at?: string;
  updated_at?: string;
  member_count?: string;
};
export type FileTypeEnum = 1 | 2 | 3 | 4;
export type FileUploadStatusEnum = 1 | 2 | 3 | 4 | 9;
export type FileUpload = {
  name?: string | null;
  file_type?: FileTypeEnum;
  data_file: string;
  review_data?: any | null;
  status?: FileUploadStatusEnum;
  messages?: string | null;
  organization?: number | null;
  created_by?: number | null;
  row_id?: number;
  row_info?: any | null;
  delete_row?: number;
  import_to_db?: number;
  re_process_data?: number;
  delete_if_not_uploaded?: number;
  create_update_record?: number;
};
export type FileUploadRead = {
  id: number;
  name?: string | null;
  file_type?: FileTypeEnum;
  data_file: string;
  review_data?: any | null;
  status?: FileUploadStatusEnum;
  status_text: string;
  messages?: string | null;
  organization?: number | null;
  created_by?: number | null;
  created_at: string;
  updated_at: string;
  row_id?: number;
  row_info?: any | null;
  delete_row?: number;
  import_to_db?: number;
  re_process_data?: number;
  delete_if_not_uploaded?: number;
  create_update_record?: number;
};
export const {
  useApiPortalV1TeamsListQuery,
  useApiPortalV1TeamsCreateMutation,
  useApiPortalV1TeamsRetrieveQuery,
  useApiPortalV1TeamsUpdateMutation,
  useApiPortalV1TeamsPartialUpdateMutation,
  useApiPortalV1TeamsDestroyMutation,
  useApiPortalV1TeamsLeadersRetrieveQuery,
  useApiPortalV1TeamsMembersRetrieveQuery,
  useApiPortalV1TeamsSetLeaderCreateMutation,
  useApiPortalV1TeamsSetMembersCreateMutation,
  useApiPortalV1TeamsAllRetrieveQuery,
  useApiPortalV1TeamsExportRetrieveQuery,
  useApiPortalV1TeamsImportCreateMutation,
  useApiPortalV1TeamsImportTemplateRetrieveQuery,
  useApiPortalV1TeamsLeaderTeamsRetrieveQuery,
  useApiPortalV1TeamsMineRetrieveQuery,
  useApiPortalV1TeamsOrganizationMembersRetrieveQuery,
  useApiPortalV1TeamsRebuildMembersCreateMutation,
} = injectedRtkApi;
